module.exports = __webpack_public_path__ + "static/img/copycheck_detail.1656619.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/copycheck_detail.jpg
// module id = mJEO
// module chunks = 25